import { getChatAttribute } from './ChatMessageAttributes';
import { ChatMessage } from './PromptChatAdapter';

const IS_CHANGE_ATTRIBUTE = 'IsChange';
const BUILD_ID_ATTRIBUTE = 'BuildId';

export function isChangeChatMessage(message: ChatMessage): boolean {
	return getChatAttribute(message.attributes, IS_CHANGE_ATTRIBUTE)?.trim().toLowerCase() === 'true';
}

export function getReactChangeBuildId(message: ChatMessage): string | undefined {
	const buildId = getChatAttribute(message.attributes, BUILD_ID_ATTRIBUTE)?.trim();
	return buildId || undefined;
}
